import React from "react";
import HeroSection2 from "./../components/HeroSection2";
import FeatureSection from "../components/FeatureSection";
import ContentCardsSection from "./../components/ContentCardsSection";
import TestimonialsSection from "./../components/TestimonialsSection";
import ClientsSection from "./../components/ClientsSection";
import CtaSection from "./../components/CtaSection";

import hi from "../assets/hi.jpeg";
import inspect from "../assets/inspect-bitmoji.jpeg";
import talksoon from "../assets/talksoon.jpeg";
import aww from "../assets/aww.jpeg";

function IndexPage(props) {
  return (
    <>
      <HeroSection2
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="I'm Jason Basuil"
        subtitle="I'm a Software Engineer based in the SF Bay Area. I love thoughtfully creating and carefully building experiences for others that allow them to do more of what they want. Whether that’s building client-side front-end experiences for users or helping students realize their potential, I am motivated to help others achieve more of what they want."
        image={hi}
      ></HeroSection2>
      <FeatureSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Experience"
        subtitle="I have about 2 years worth of programming experience starting in 2018."
      ></FeatureSection>
      <ClientsSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Tech Stack"
        subtitle="What I use most regularly. I definitely know more :)"
      ></ClientsSection>
      <div>
        <img
          src={inspect}
          alt="inspect bitmoji"
          style={{ float: "left" }}
        ></img>
      </div>
      <ContentCardsSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Projects"
        subtitle="Here are few technical projects I've worked on over the years."
      ></ContentCardsSection>
      <div>
        <img src={aww} alt="aww bitmoji" style={{ float: "right" }}></img>
      </div>
      <TestimonialsSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Testimonials"
        subtitle="Some kind people I've worked with who think I'm competent."
      ></TestimonialsSection>
      <CtaSection
        color="link"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Looking for that piece of paper?"
        buttonText="View my resume"
        buttonOnClick={() => {
          window.open(
            "https://docs.google.com/document/d/1jmf4qkWuSmNfInkB45Kw1U6NtcPGo0Wu0wOi3ZxS-PI/edit?usp=sharing"
          );
        }}
      ></CtaSection>
      <div>
        <img
          src={talksoon}
          alt="Talk soon"
          style={{ maxWidth: "398px", float: "right" }}
        ></img>
      </div>
    </>
  );
}

export default IndexPage;
